module.exports = __webpack_public_path__ + "static/media/Roboto-Regular22.3e1af3ef.ttf";